import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { AppointmentForm } from "./Appointment";
import { DOCTOR } from "@/data";

export const AppointmentDialog = ({ open, onOpenChange }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-lg bg-[#FDFBF7] border-black/5 p-0 overflow-hidden gap-0" data-testid="appointment-dialog">
      <div className="px-7 pt-7 pb-5 bg-[#B9735A]">
        <DialogHeader>
          <DialogTitle className="font-serif-display text-3xl text-[#FDFBF7] text-left font-light">
            Book your consultation
          </DialogTitle>
          <DialogDescription className="text-[#FDFBF7]/85 text-left">
            Share a few details with {DOCTOR.name}'s team — no obligation, we'll get back quickly.
          </DialogDescription>
        </DialogHeader>
      </div>
      <div className="p-7">
        <AppointmentForm compact onDone={() => onOpenChange(false)} />
      </div>
    </DialogContent>
  </Dialog>
);
